import { CartItem, CartItemSelection, PreviewEvent, WidgetSettings } from '@gsc/types'

export interface WidgetData {
  [key: string]: string[]
}

export interface OpenUrlParams {
  url: string
  target: '_blank' | '_self'
  label?: string
}

export enum Placement {
  WebSite = 'website',
  GetLink = 'getlink',
}

export interface IRuntimeSettings {
  sessionLength?: number
  storage?: string
  storagePrefix?: string

  siteId?: string
  serverUrl?: string
  placement?: string

  // server event tracking
  events?: string[]

  //locale?: string
  //timezone?: string
  currency?: string
  currencyFormat?: string

  trackGA?: boolean | string | any
  trackGTM?: boolean | string | any

  trackLocation?: boolean

  recaptcha?: {
    siteKey: string
    serverKey: string
    action: string
  }

  logoUrl?: string

  previewInteractive?: boolean
  onPreviewEvent?: (evt: PreviewEvent) => void
}

// TODO: replace with
// export interface IRuntimeActionDispatcher {
//   dispatch(RuntimeAction: action): Promise<boolean>
// }

export interface IWidgetRuntime {
  showWidget(widgetId: number, actorId?: number): Promise<boolean>

  closeWidget(widgetId: number): Promise<boolean>

  sendData(widgetId: number, data: WidgetData): Promise<boolean>

  openUrl(widgetId: number, params: OpenUrlParams): Promise<boolean>

  copyToClipboard(widgetId: number, text: string): Promise<boolean>

  addToCart(widgetId: number, selection: CartItemSelection, items: CartItem[], redirect: string): Promise<boolean>

  applyCoupon(widgetId: number, coupon: string, redirect: string): Promise<boolean>

  sendPreviewEvent(evt: PreviewEvent): Promise<boolean>
}

export interface IRuntime {
  run(widgets: WidgetSettings[]): void

  apiCall(input: unknown): Promise<boolean>
}

export interface IWidget {
  readonly shown: boolean
  readonly date: Date

  close(): void
}

export interface IWidgetRendererOptions {
  previewInteractive?: boolean
  logoUrl?: string
}

export interface IWidgetRenderer {
  isRendered(): boolean

  render(ctx?: { [key: string]: any }): void

  createWidget(settings: WidgetSettings): Promise<IWidget>

  updateContext(ctx: { [key: string]: any }): void

  updateOptions(options: Partial<IWidgetRendererOptions>): void
}

export interface IWidgetRendererFactory {
  createWidgetRenderer(runtime: IWidgetRuntime, options: IWidgetRendererOptions): IWidgetRenderer
}
